function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "glow",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.27 0 0 0 0 0.27 0 0 0 0 0.27 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2",
  values: "0 0 0 0 0.67 0 0 0 0 0.27 0 0 0 0 0.27 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter3"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter3",
  result: "shadowBlurOuter3",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter3",
  result: "shadowMatrixOuter3",
  values: "0 0 0 0 0.27 0 0 0 0 0.27 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter4"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter4",
  result: "shadowBlurOuter4",
  stdDeviation: 8
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter4",
  result: "shadowMatrixOuter4",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter5"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter5",
  result: "shadowBlurOuter5",
  stdDeviation: 0
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter5",
  result: "shadowMatrixOuter5",
  values: "0 0 0 0 0.27 0 0 0 0 0.27 0 0 0 0 0.27 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feMerge", {
  result: "merge-0"
}, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter3"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter4"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter5"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  filter: "url(#glow)",
  id: "boulder-b",
  className: "path",
  d: "M372.867,234.644c-10.716-20.554-31.858-57.386-56.997-81.798c-6.741-6.546-18.646-6.017-25.106,0.802 c-17.597,18.536-48.538,56.958-53.359,102.216c-1.591,14.896-2.26,30.604-2.692,45.828h-28.068 c1.44-39.825,5.035-87.925,9.019-132.813h12.465c1.775,3.039,5.033,5.113,8.8,5.113c5.643,0,10.219-4.579,10.219-10.231 c0-5.643-4.576-10.213-10.219-10.213c-3.768,0-7.033,2.082-8.8,5.104h-11.563c0.845-9.303,1.705-18.408,2.559-27.241h13.26 c1.768,3.038,5.029,5.104,8.793,5.104c5.643,0,10.219-4.57,10.219-10.223c0-5.643-4.576-10.213-10.219-10.213 c-3.764,0-7.033,2.07-8.793,5.104h-12.278c0.936-9.538,1.852-18.661,2.733-27.243h13.805c1.779,3.04,5.029,5.105,8.797,5.105 c5.643,0,10.219-4.57,10.219-10.223c0-5.646-4.576-10.213-10.219-10.213c-3.768,0-7.025,2.062-8.797,5.104h-12.747 c3.094-29.709,5.566-51.243,6.271-57.395c0.693-4.412,1.36-8.684,2.012-12.815c0,0,0.533-3.366,1.179-7.536 c0.657-4.152-2.136-6.734-6.226-5.761l-7.421,1.781c-54.998,13.148-102.548,12.531-103.017,12.509l-0.357,20.434 c1.872,0.024,42.441,0.595,93.351-9.782c-0.204,1.364-0.431,2.855-0.675,4.404c-6.321,25.15-46.811,188.236-60.135,290.157 c-14.475,110.682,24.582,120.893,63.792,125.141c39.219,4.26,66.465-8.513,77.533-88.524 c9.767-70.695,32.829-98.867,73.276-105.079C372.764,249.824,377.216,242.975,372.867,234.644z M180.465,357.873 c-5.643,0-10.219-4.585-10.219-10.228s4.576-10.211,10.219-10.211c5.641,0,10.225,4.568,10.225,10.211 C190.682,353.288,186.098,357.873,180.465,357.873z M180.465,315.293c-5.643,0-10.219-4.568-10.219-10.211 s4.576-10.211,10.219-10.211c5.641,0,10.225,4.568,10.225,10.211C190.682,310.725,186.098,315.293,180.465,315.293z  M180.465,266.214c-6.277,0-11.365-5.077-11.365-11.36c0-6.272,5.095-11.357,11.365-11.357c6.284,0,11.363,5.094,11.363,11.357 C191.828,261.137,186.749,266.214,180.465,266.214z M188.42,230.756c-4.391,0-7.961-3.566-7.961-7.967 c0-4.399,3.564-7.96,7.961-7.96c4.396,0,7.953,3.561,7.953,7.96C196.373,227.19,192.816,230.756,188.42,230.756z M214.42,389.511 c-4.681-1.595-7.125-14.595-8.023-34.765h26.465C231.041,378.586,226.721,393.707,214.42,389.511z M233.483,344.524h-27.401 c-0.172-9.734-0.068-20.742,0.254-32.621h28.126C234.179,323.445,233.962,334.529,233.483,344.524z M255.658,357.873 c-5.643,0-10.219-4.585-10.219-10.228s4.576-10.211,10.219-10.211s10.227,4.568,10.227,10.211S261.301,357.873,255.658,357.873z  M255.658,315.293c-5.643,0-10.219-4.568-10.219-10.211s4.576-10.211,10.219-10.211s10.227,4.568,10.227,10.211 S261.301,315.293,255.658,315.293z"
}), /*#__PURE__*/React.createElement("path", {
  filter: "url(#glow)",
  id: "boulder-u",
  className: "path",
  d: "M76.599,30.979c15.701,4.412,35.656,3.753,35.656,3.753l0.815-19.785c0,0-11.986,1.347-23.927,3.833 C82.7,20.123,60.897,26.566,76.599,30.979z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

function SvgSaxophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "445.57px",
    height: "445.571px",
    viewBox: "0 0 445.57 445.571",
    style: {
      enableBackground: "new 0 0 445.57 445.571"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaxophone);
export default __webpack_public_path__ + "static/media/saxophone.c865079d.svg";
export { ForwardRef as ReactComponent };